<template>
  <div :class="['modalsContainer', { active: openModal }]">
    <NewMedicalMeeting :open="isOpen('newMedicalMeeting')" />
    <NewPatient :open="isOpen('newPatient')" />
    <CancelMeeting :open="isOpen('cancelMeeting')" />
    <NewMedicWelcome :open="isOpen('newMedicWelcome')" />
    <RequestedInterConsultation :open="isOpen('requestedInterConsultation')" />
    <div class="backdrop" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import NewMedicalMeeting from './NewMedicalMeeting';
import NewPatient from './NewPatient';
import CancelMeeting from './CancelMeeting';
import NewMedicWelcome from './NewMedicWelcome';
import { RequestedInterConsultation } from '@/components/Modals';

export default {
  name: 'ModalsContainer',

  components: {
    NewMedicalMeeting,
    NewPatient,
    CancelMeeting,
    NewMedicWelcome,
    RequestedInterConsultation,
  },

  computed: {
    ...mapState('dashboard', ['openModal']),
  },

  methods: {
    ...mapActions('dashboard', ['toggleModal']),
    isOpen(modalName) {
      return this.openModal === modalName;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
